<template>
    <div style="text-align:left">
        <Breadcrumb style="margin: 0px 10px 20px">
            <BreadcrumbItem>人群管理</BreadcrumbItem>
        </Breadcrumb>
        <Card>
            <Form ref="form" :model="formItem" :label-width="100">
                <Row>
                    <Col span="6">
                    <FormItem label="人群名称">
                        <Input v-model="formItem.crowd_name"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <Button @click="handleSearch" style="margin-left:30px"
                        type="primary">搜索</Button>
                    </Col>
                </Row>
            </Form>
            <Button @click="handleCreate()" style="margin:0px 10px 20px" type="primary">新增</Button>
            <Table :columns="columns" :data="data"></Table>
            <Page show-total :current="page" @on-change="changePage" style="margin-top: 10px; text-align: right"
                :total="total_count" :page-size="20" />
            <Modal v-model="modal1" title="新增人群" width='300' @on-ok="ok" @on-cancel="cancel">
                <Form ref="formInline" :model="formInline" :rules="ruleInline" inline>
                    <FormItem label="人群名称" prop="crowd_name" style="width: 100%">
                        <Input v-model="formInline.crowd_name"></Input>
                    </FormItem>
                    <FormItem label="备注" style="width: 100%">
                        <Input v-model="formInline.description"></Input>
                    </FormItem>
                </Form>
            </Modal>
            <Modal v-model="modal2" title="修改人群" width='300' @on-ok="handleEdit" @on-cancel="">
                <Form ref="updateFormInline" :model="updateFormInline" :rules="ruleInline" inline>
                    <FormItem label="人群名称" prop="crowd_name" style="width: 100%">
                        <Input v-model="updateFormInline.crowd_name"></Input>
                    </FormItem>
                    <FormItem label="备注" style="width: 100%">
                        <Input v-model="updateFormInline.description"></Input>
                    </FormItem>
                </Form>
            </Modal>
            <Modal
                v-model="modal3"
                :title="msg_title"
                width='600'
                footer-hide>
                <Table :columns="msg_columns" :data="msg_data"></Table>
            </Modal>
        </Card>
    </div>
</template>
<script>
import { crowdList, createCrowd, deleteCrowd, updateCrowd } from "@/request/api"
import Cookies from 'js-cookie';
export default {
    name: 'crowdAdmin',
    meta: {},
    data() {
        return {
            formItem: {
                crowd_name: ''
            },
            columns: [
                {
                    title: "人群id",
                    key: "crowd_id",
                    align: "center"
                },
                {
                    title: "人群名称",
                    key: "crowd_name",
                    align: "center"
                },
                {
                    title: "备注",
                    key: "description",
                    align: "center"
                },
                {
                    title: "创建时间",
                    key: "created_at",
                    align: "center"
                },
                {
                    title: "创建者",
                    key: "user_name",
                    align: "center"
                },
                {
                    title: "操作",
                    key: "action",
                    align: "center",
                    width: '200',
                    render: (h, params) => {
                        return h("div", [
                            h("Button", {
                                props: {
                                    type: "text",
                                    size: "small",
                                },
                                on: {
                                    click: () => {
                                        this.$router.push({
                                            name: "recipientAdmin",
                                            query: {
                                                crowd_id: params.row.crowd_id,
                                                crowd_name: params.row.crowd_name
                                            },
                                        });
                                    },
                                },
                            }, "详情"),
                            h("Button", {
                                props: {
                                    type: "text",
                                    size: "small",
                                },
                                on: {
                                    click: () => {
                                        this.editCrowd(params.index)
                                    },
                                },
                            }, "修改"),
                            h("Button", {
                                props: {
                                    type: "text",
                                    size: "small",
                                },
                                on: {
                                    click: () => {
                                        this.$Modal.confirm({
                                            title: "提示",
                                            content: "是否删除该项？",
                                            onOk: () => {
                                                this.remove(params.index)
                                            },
                                        });
                                    },
                                },
                            }, "删除"),
                        ]);
                    },
                },
            ],
            data: [],
            total_count: 0,
            page: 1,
            formInline: {
                crowd_name: '',
                description: ''
            },
            ruleInline: {
                crowd_name: [
                    { required: true, message: '不能为空', trigger: 'blur' }
                ]
            },
            modal1: false,
            modal2: false,
            
            updateFormInline: {
                crow_id: '',
                crowd_name: '',
                description: ''
            },
            modal3: false,
            msg_title: '',
            msg_data: [],
            msg_columns: [
                {
                    title: "投放计划id",
                    key: "plan_id",
                    align: "center"
                },
                {
                    title: "投放计划名称",
                    key: "plan_name",
                    align: "center"
                },
                {
                    title: "状态",
                    key: "status",
                    align: "center"
                },
            ]
        };
    },
    methods: {
        getData(page = 1, page_size = 20, crowd_name) {
            crowdList({ page, page_size, crowd_name }).then(res => {
                if (res.data.code == 200) {
                    this.data = res.data.data.crowds
                    this.total_count = res.data.data.total
                    this.page = page
                }
            })
        },
        handleSearch(){
            this.getData(1, 20, this.formItem.crowd_name);
        },
        changePage(page) {
            this.getData(page, 20, this.formItem.crowd_name);
        },
        handleCreate() {
            this.modal1 = true
        },
        ok() {
            this.$refs['formInline'].validate((valid) => {
                if (valid) {
                    createCrowd(
                        {
                            crowd_name: this.formInline.crowd_name,
                            description: this.formInline.description
                        }
                    ).then(({ data: res }) => {
                        if (res.code == 200) {
                            this.getData(this.page, 20, this.formItem.crowd_name)
                        }
                        this.$Message.info(res.msg);
                        this.formInline = {
                            app_user_id: '',
                            description: ''
                        }
                    })
                } else {
                    this.$Message.error('Fail!');
                }
            })
        },
        cancel() {
            this.modal1 = false,
            this.formInline = {
                app_user_id: '',
                description: ''
            }
        },
        editCrowd(index) {
            this.updateFormInline.crowd_id = this.data[index].crowd_id
            this.updateFormInline.crowd_name = this.data[index].crowd_name
            this.updateFormInline.description = this.data[index].description
            this.modal2 = true
        },
        handleEdit(){
            updateCrowd(
                this.updateFormInline
            ).then(({ data: res }) => {
                if (res.code == 200) {
                    this.getData(this.page, 20, this.formItem.crowd_name)
                    this.$Message.info(res.msg);
                } else {
                    this.$Message.error(res.msg);
                }
            })
        },
        remove(index) {
            deleteCrowd(
                {
                    crowd_id: this.data[index].crowd_id
                }
            ).then(({ data: res }) => {
                if (res.code == 200) {
                    this.getData(this.page, 20, this.formItem.crowd_name)
                    this.$Message.info(res.msg);
                }else{
                    this.msg_title = res.msg
                    this.msg_data = res.data.sub_msg
                    this.modal3 = true
                }
            })
        },
    },
    created() {
        Cookies.set('active_name', '7');
        this.getData(1, 20, this.formItem.crowd_name)
    },
};
</script>


// WEBPACK FOOTER //
// src/views/Crwod/CrowdList.vue